(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    function initHoverMenus() {
      if (window.innerWidth < 990) return;

      document.querySelectorAll('.header__inline-menu details.mega-menu').forEach(function(details) {
        if (details.dataset.hoverBound === 'true') return;
        details.dataset.hoverBound = 'true';

        var item = details.closest('li');
        if (!item) return;

        var closeTimer;

        function openMenu() {
          window.clearTimeout(closeTimer);
          details.setAttribute('open', '');
        }

        function closeMenu() {
          window.clearTimeout(closeTimer);
          closeTimer = window.setTimeout(function() {
            details.removeAttribute('open');
          }, 120);
        }

        item.addEventListener('mouseenter', openMenu);
        item.addEventListener('mouseleave', closeMenu);
        item.addEventListener('focusin', openMenu);
        item.addEventListener('focusout', function() {
          window.clearTimeout(closeTimer);
          closeTimer = window.setTimeout(function() {
            if (!item.contains(document.activeElement)) {
              details.removeAttribute('open');
            }
          }, 120);
        });

        var summary = details.querySelector('summary');
        if (summary) {
          summary.addEventListener('click', function(e) {
            if (window.innerWidth >= 990 && !e.target.closest('a')) {
              e.preventDefault();
            }
          });
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHoverMenus);
    } else {
      initHoverMenus();
    }

    window.addEventListener('load', initHoverMenus);
    window.addEventListener('resize', initHoverMenus);
  })();

  (function() {
    var hw = document.querySelector('.header-wrapper');
    if (!hw) return;

    function updateState() {
      var scrolled = window.scrollY > 50;
      hw.classList.toggle('lux-scrolled', scrolled);
    }

    hw.addEventListener('mouseenter', function() { hw.classList.add('lux-hovered'); });
    hw.addEventListener('mouseleave', function() { hw.classList.remove('lux-hovered'); });

    window.addEventListener('scroll', updateState, { passive: true });
    window.addEventListener('load', updateState);
    updateState();
  })();

  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
